// extracted by mini-css-extract-plugin
module.exports = {"textArea":"filesTab_textArea__21Q0M","controlPanel":"filesTab_controlPanel__1vbha","fileListContainer":"filesTab_fileListContainer__2Gg0f"};